export function initShowCardTabs(rootSel = '.ticket-booth-show-card') {
	const tabBtnSel = '.ticket-booth-show-card__tabs-button';
	const panelSel = '.ticket-booth-show-card__panel';
	function activateTab(card, tabKey) {
		if (!card || !tabKey) {
			return;
		}

		// Buttons
		card.querySelectorAll(tabBtnSel).forEach((btn) => {
			const on = btn.getAttribute('data-tab') === tabKey;
			btn.classList.toggle('is-active', on);
			btn.setAttribute('aria-selected', on ? 'true' : 'false');

			if (!btn.hasAttribute('role')) {
				btn.setAttribute('role', 'tab');
			}

			const panelId = `${ tabKey }-panel-${ card.dataset.cardId || '' }`;
			if (!btn.id) {
				btn.id = `tab-${ tabKey }-${ Math.random().toString(36).slice(2) }`;
			}
			btn.setAttribute('aria-controls', panelId);
		});

		// Panels
		card.querySelectorAll(panelSel).forEach((p) => {
			const on = p.getAttribute('data-panel') === tabKey;
			p.classList.toggle('is-active', on);
			p.toggleAttribute('hidden', !on);
			if (!p.hasAttribute('role')) {
				p.setAttribute('role', 'tabpanel');
			}

			const panelId = `${ tabKey }-panel-${ card.dataset.cardId || '' }`;
			p.id = panelId;

			const activeBtn = card.querySelector(
				`${ tabBtnSel }[data-tab="${ tabKey }"]`
			);
			if (activeBtn) {
				p.setAttribute('aria-labelledby', activeBtn.id);
			}
		});
	}

	function bindDelegatedTabs() {
		// Click delegation (survives content refresh)
		document.addEventListener('click', (e) => {
			const btn = e.target.closest(tabBtnSel);
			if (!btn) {
				return;
			}
			const card = btn.closest(rootSel);
			if (!card) {
				return;
			}
			e.preventDefault();
			activateTab(card, btn.getAttribute('data-tab') || 'dates');
		});
	}

	function initialiseExistingCards() {
		document.querySelectorAll(rootSel).forEach((card, ix) => {
			if (!card.dataset.cardId) {
				card.dataset.cardId = String(ix + 1);
			}
			const active =
        card.querySelector(`${ tabBtnSel }.is-active`)?.getAttribute('data-tab') ||
        'dates';
			activateTab(card, active);
		});
	}

	// Initialise immediately
	initialiseExistingCards();
	bindDelegatedTabs();
}
